import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { setLang, SupportedLang } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

const LABELS: Record<SupportedLang, string> = { es: "ES", en: "EN", pt: "PT" };
const NAMES: Record<SupportedLang, string> = {
  es: "Español",
  en: "English",
  pt: "Português (BR)",
};

export function LanguageSwitcher({ variant = "portal" }: { variant?: "portal" | "landing" }) {
  const { i18n, t } = useTranslation();
  const current = ((i18n.language || "es").split("-")[0] as SupportedLang) in LABELS
    ? ((i18n.language || "es").split("-")[0] as SupportedLang)
    : "es";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={t("common.language")}
        className={cn(
          "inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-[11px] font-mono uppercase tracking-widest transition-colors",
          variant === "portal"
            ? "text-muted-foreground hover:text-foreground border border-transparent hover:border-muted/30"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        <Globe className="h-3.5 w-3.5" />
        {LABELS[current]}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[8rem]">
        {(Object.keys(LABELS) as SupportedLang[]).map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLang(code)}
            className={cn("text-xs font-mono", code === current && "text-accent")}
          >
            <span className="w-6 inline-block">{LABELS[code]}</span>
            <span className="text-muted-foreground">{NAMES[code]}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
